import { IAnalyticsEventToggle, IAnalyticsEventToggleArgument } from './types';

export const toggleClicked = (
  toggle: IAnalyticsEventToggleArgument,
): IAnalyticsEventToggle => {
  return {
    eventName: 'Toggle Clicked',
    object_type: toggle.name,
    object_name: toggle.state ? 'enabled' : 'disabled',
  };
};
